module.exports = __webpack_public_path__ + "img/service.781723c3.svg";